import { createI18n } from '@shopModules/vue-i18n';
import ru from './locales/ru.js';

const messages = { ru };

export default createI18n({
  legacy: false,
  locale: 'ru',
  fallbackLocale: 'en',
  messages,
});
